import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dynamicWord"]
  static values = { words: { type: Array, default: ["Gym", "Studio", "Dojo"] } }

  connect() {
    this.words = this.wordsValue.length ? this.wordsValue : ["Gym", "Studio", "Dojo"]
    this.currentWordIndex = 0
    this.startWordRotation()
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  startWordRotation() {
    if (this.words.length > 1 && this.hasDynamicWordTarget) {
      this.interval = setInterval(() => {
        this.swapWord()
      }, 3500)
    }
  }

  swapWord() {
    this.dynamicWordTarget.style.opacity = '0.5'

    setTimeout(() => {
      this.currentWordIndex = (this.currentWordIndex + 1) % this.words.length
      this.dynamicWordTarget.textContent = this.words[this.currentWordIndex]
      this.dynamicWordTarget.style.opacity = '1'
    }, 300)
  }
}
